import { declareString } from "@1js/localization";

export const RecentlySavedTitle = declareString("promptLibrary.recentlySaved", {
  text: "Recently saved",
  comment:
    "Text which appears on the bookmarked prompts tab for the recently saved prompts section.",
});

export const RecentlyLikedTitle = declareString("promptLibrary.recentlyLiked", {
  text: "Recently liked",
  comment:
    "Text which appears on the bookmarked prompts tab for the recently liked prompts section.",
});
